import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const KEY = 'emina_cookies';

export default function CookieBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(KEY);
      if (!stored) setVisible(true);
    } catch { /* ignore */ }
  }, []);

  function accept() {
    try {
      localStorage.setItem(KEY, JSON.stringify({ accepted_at: new Date().toISOString(), version: 1 }));
    } catch { /* ignore */ }
    setVisible(false);
  }

  if (!visible) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] bg-slate-900 text-white border-t border-slate-700 shadow-2xl" data-testid="cookie-banner">
      <div className="max-w-5xl mx-auto px-4 py-3 flex flex-col sm:flex-row items-center gap-3">
        <p className="text-sm flex-1 text-gray-200">{t('cookies.message')}</p>
        <div className="flex gap-2 shrink-0">
          <a href="/postavke-kolacica" className="px-4 py-2 text-sm text-gray-300 hover:text-white underline underline-offset-4" data-testid="cookie-settings-btn">
            {t('cookies.settings')} →
          </a>
          <button onClick={accept} className="px-5 py-2 bg-red-600 hover:bg-red-700 text-sm font-bold rounded-lg" data-testid="cookie-accept-btn">
            {t('cookies.accept')}
          </button>
        </div>
      </div>
    </div>
  );
}
